

































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
	name: 'SiteHeader',
})
export default class SiteHeader extends Vue {
	public loggingOut: boolean = false;

	public logout(): void {
		this.loggingOut = true;
		setTimeout(() => {
			this.loggingOut = false;
			this.$store.dispatch('AuthModule/logout');
			location.reload();
		}, 1000);
	}
}
